<template>
  <v-expansion-panels accordion>
    <v-expansion-panel class="elevation-1">
      <v-expansion-panel-header color="#f2f2f2" class="px-4">
        <span>Filtrar por</span>
        <template v-slot:actions>
          <v-icon color="black"> mdi-chevron-down </v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row class="mt-2 pb-1">
          <v-col cols="12" md="2">
            <v-menu
              ref="menu"
              v-model="isAuthDateStartOpen"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedStartAuthDate"
                  label="Data autorização início"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="value.initialAuthDate" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu
              ref="menu1"
              v-model="isAuthDateEndOpen"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedEndAuthDate"
                  label="Data autorização fim"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="value.endAuthDate" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu
              ref="menu"
              v-model="isCompletionDateStartOpen"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formattedStartCompletionDate"
                  label="Data conclusão início"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="value.initialCompletionDate" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu
              ref="menu1"
              v-model="isCompletionDateEndOpen"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formattedEndCompletionDate"
                  label="Data conclusão fim"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="value.endCompletionDate" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu ref="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formattedStartForecastDate"
                  label="Data previsão início"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="value.initialForecastDate" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu ref="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formattedEndForecastDate"
                  label="Data previsão fim"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="value.endForecastDate" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              @change="onStateChange"
              v-model="value.stateId"
              label="Estado de Entrega"
              :items="states"
              item-text="name"
              item-value="id"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="value.cityId"
              label="Município de Entrega"
              :items="cities"
              item-text="name"
              item-value="id"
              :disabled="!value.stateId"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="value.hasReceiptFilter"
              label="Possui Canhoto"
              :items="hasReceiptOptions"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="value.isReceiptValidFilter"
              label="Canhoto Validado"
              :items="isReceiptValidOptions"
              clearable
            ></v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              v-model="value.isReceiptDownloaded"
              label="Canhoto Baixado"
              :items="booleanOptions"
              clearable
            ></v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              v-model="value.isReceiptPurged"
              label="Canhoto Expurgado"
              :items="booleanOptions"
              clearable
            ></v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="value.recipient" label="Destinatário"></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              v-model="value.status"
              :items="statuses"
              item-text="name"
              item-value="id"
              label="Status"
              small-chips
              deletable-chips
              multiple
            ></v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-combobox
              v-model="value.boardingNumber"
              :search-input.sync="boardingNumberInput"
              append-icon=""
              label="Número externo da Carga"
              hide-selected
              multiple
              chips
              deletable-chips
              @keydown.native="filterInput"
              @change="saveBoardingNumber"
              ></v-combobox>
          </v-col>
          <v-col cols="12" md="4">
            <v-combobox
              v-model="value.numberCTE"
              :search-input.sync="numberCTEInput"
              append-icon=""
              label="Número CTE"
              hide-selected
              multiple
              chips
              deletable-chips
              @keydown.native="filterInput"
              @change="saveCteNumber"
              ></v-combobox>
          </v-col>
          <v-col cols="12" md="4">
            <v-combobox
              v-model="value.keyNfe"
              :search-input.sync="keyNfeInput"
              append-icon=""
              label="Número da Nota Fiscal"
              hide-selected
              multiple
              chips
              deletable-chips
              @keydown.native="filterInput"
              @change="saveNfeNumber"
              ></v-combobox>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="value.numberInvoiceId" label="Id da Fatura"></v-text-field>
          </v-col>

          <v-col cols="12" class="d-flex justify-end align-center">
            <v-btn :disabled="!isExportButtonDisabled" elevation="2" color="info" @click="$emit('exportClick')">
              EXPORTAR DADOS
            </v-btn>
            <v-btn
              @click="clearFilters"
              :disabled="!hasFilters"
              elevation="2"
              color="red"
              class="mx-2"
              style="color: white"
            >
              Limpar filtros
            </v-btn>
            <v-btn @click="search" :disabled="!hasFilters" elevation="2" color="green" style="color: white">
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapActions } from 'vuex';
import comboboxFormatter from '@/utils/comboboxFormatter';
import allowedChars from '@/utils/allowedChars';
export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        isReceiptDownloaded: null,
        isReceiptPurged: null,
        initialAuthDate: null,
        initialCompletionDate: null,
        initialForecastDate: null,
        endAuthDate: null,
        endCompletionDate: null,
        endForecastDate: null,
        stateId: null,
        cityId: null,
        hasReceiptFilter: null,
        isReceiptValidFilter: null,
        status: [],
        boardingNumber: [],
        keyNfe: [],
        numberCTE: [],
        numberInvoiceId: null
      })
    },
    states: {
      type: Array,
      default: () => []
    },
    cities: {
      type: Array,
      default: () => []
    },
    statuses: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    keyNfeInput: '',
    boardingNumberInput: '',
    numberCTEInput: '',
    isAuthDateStartOpen: false,
    isAuthDateEndOpen: false,
    isCompletionDateStartOpen: false,
    isCompletionDateEndOpen: false,
    booleanOptions: [
      { text: 'Sim', value: true },
      { text: 'Não', value: false }
    ],
    hasReceiptOptions: [
      { text: 'Sim', value: true },
      { text: 'Não', value: false }
    ],
    isReceiptValidOptions: [
      { text: 'Sim', value: true },
      { text: 'Não', value: false }
    ]
  }),

  watch: {
    hasFilters: {
      handler(value) {
        if (!value) {
          this.search();
        }
      },
      deep: true
    }
  },

  computed: {
    hasFilters() {
      const { boardingNumber, numberCTE, keyNfe, status, ...rest } = this.value;
      const arrayFilters = [boardingNumber, numberCTE, keyNfe, status];
      const inputFilters = Object.values(rest);

      let hasArraysFilters = false;
      const hasInputFilters = inputFilters.some((inputFilter) => inputFilter !== null);

      arrayFilters.forEach((arrayFilter) => {
        if (arrayFilter !== null) {
          if (arrayFilter.some((array) => array)) {
            hasArraysFilters = true;
          }
        }
      });

      return hasArraysFilters || hasInputFilters;
    },
    isExportButtonDisabled() {
      return !!this.value.initialAuthDate && !!this.value.endAuthDate;
    },
    formattedStartAuthDate() {
      if (!this.value.initialAuthDate) return '';
      const [year, month, day] = this.value.initialAuthDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndAuthDate() {
      if (!this.value.endAuthDate) return '';
      const [year, month, day] = this.value.endAuthDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedStartCompletionDate() {
      if (!this.value.initialCompletionDate) return '';
      const [year, month, day] = this.value.initialCompletionDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndCompletionDate() {
      if (!this.value.endCompletionDate) return '';
      const [year, month, day] = this.value.endCompletionDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedStartForecastDate() {
      if (!this.value.initialForecastDate) return '';
      const [year, month, day] = this.value.initialForecastDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndForecastDate() {
      if (!this.value.endForecastDate) return '';
      const [year, month, day] = this.value.endForecastDate.split('-');
      return `${day}/${month}/${year}`;
    }
  },

  methods: {
    ...mapActions('AdressStore', ['fetchStates', 'fetchCities']),
    ...mapActions('NfeStore', ['fetchStatus']),
    clearFilters() {
      this.$emit('input', {
        initialForecastDate: null,
        endForecastDate: null,
        isReceiptDownloaded: null,
        isReceiptPurged: null,
        initialAuthDate: null,
        initialCompletionDate: null,
        endAuthDate: null,
        endCompletionDate: null,
        stateId: null,
        cityId: null,
        hasReceiptFilter: null,
        isReceiptValidFilter: null,
        status: [],
        boardingNumber: [],
        numberCTE: [],
        keyNfe: [],
        numberInvoiceId: null
      });
      this.search();
    },

    search() {
      this.$emit('searchClick');
    },

    onStateChange(stateId) {
      this.$emit('stateChange', stateId);
    },

    filterInput(event) {
      return allowedChars(event, /[0-9,.;/]/);
    },
    
    saveBoardingNumber(val) {
      this.$emit('input', {
        ...this.value,
        boardingNumber: comboboxFormatter(val)
      });
    },

    saveCteNumber(val) {
      this.$emit('input', {
        ...this.value,
        numberCTE: comboboxFormatter(val)
      });
    },

    saveNfeNumber(val) {
      this.$emit('input', {
        ...this.value,
        keyNfe: comboboxFormatter(val)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}
</style>
